<template>
    <div class="banner">
        <swiper :options="swiperOptiona" ref="mySwipers" class="swiper" >
            <swiper-slide class="item" v-for="(item,index) in bList" :key="index">
                <img :src="`http://junankg.com/upload/${item.PICURL}`" alt="">
                <div class="text" :class="{'enp':$i18n.locale === 'en'}">
                    <p>
                        <span v-for="(i,idx) in item.TEXT1" :key="idx" :style="aStyle(idx)">{{i}}</span>
                    </p>
                    <p >
                        <span v-for="(i,idx) in item.TEXT2" :key="idx" :style="aStyle(idx)">{{i}}</span>
                    </p>
                    <p>
                        <span v-for="(i,idx) in item.TEXT3" :key="idx" :style="aStyle(idx)">{{i}}</span>
                    </p>
                    <i class="iconfont icon-you"></i>
                </div>
                <div class="ne">
                    <span>next</span>
                    <span></span>
                </div>
                <div class="scr">
                    <span>scrool</span>
                    <span></span>
                </div>
            </swiper-slide>
        </swiper>
        <div class="swiper-pagination">

        </div>
    </div>
</template>

<script>
    import { swiper, swiperSlide } from "vue-awesome-swiper";
    import "swiper/dist/css/swiper.css";
    import { getPicUrl} from '../util/lang'
    import '../common/jquery-1.11.3.min'
    export default {
        name: "banner",
        data(){
            return{
                bList:[],
                swiperOptiona:{
                    pagination: {
                        el: ".banner .swiper-pagination",
                        clickable: true,
                        renderBullet: function(index, className) {
                            return '<span class="' + className + '"><i></i></span>';
                        }
                    },
                    loop: true,
                    effect: 'fade',
                    init: false,
                    autoplay:{
                        disableOnInteraction: false,
                        delay: 100000
                    },
                    on:{
                        slideChangeTransitionEnd: () => {
                            this.$nextTick(() => {
                                let swiper = this.$refs.mySwipers.swiper;
                                let active = swiper.realIndex;
                                let previousIndex = swiper.previousIndex;
                                let bullets = swiper.pagination.bullets;
                                let bulletsArray = Array.from(bullets);
                                for (let i = 0; i < bulletsArray.length; i++) {
                                    $('.banner .swiper-pagination .swiper-pagination-bullet').eq(i).children('i').stop().animate({width: '0'}, 5000, "linear")
                                }
                                for (let i = 0; i < active; i++) {
                                    $('.banner .swiper-pagination .swiper-pagination-bullet').eq(i).children('i').stop().animate({width: '0'}, 5000, "linear")
                                }
                                $('.banner .swiper-pagination .swiper-pagination-bullet').eq(active).children('i').stop().animate({width: '100%'}, 5000, "linear")
                            });
                        }
                    }
                },
            }
        },
        components: {
            swiper,
            swiperSlide,
        },
        mounted(){
            if( this.$i18n.locale === 'en'){
                this.getList('12')
            }else{
                this.getList('8')
            }
        },
        methods:{
            aStyle(n){
                return {transitionDelay:n*0.05+0.05+'s'}
            },
            getList(id){
                const url = `${getPicUrl(this.$i18n.locale,'首页banner',id)}`
                this.$axios.get(url).then(res => {
                    res.data.map((item)=>{
                        item.TEXT1=item.TEXT1.split('&')
                        item.TEXT2=item.TEXT2.split('&')
                        item.TEXT3=item.TEXT3.split('&')
                    })
                    this.bList=res.data
                    setTimeout(()=>{
                        this.$refs.mySwipers.swiper.init()
                    },100)
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
.banner{
    width:100%;
    height:100vh;
    position: relative;
    .swiper{
        height:100%;
        .item{
            position: relative;
            overflow: hidden;
            img{
                width:100%;
                height:100%;
                object-fit: cover;
                display: block;
                z-index: 1;
                cursor: pointer;
            }
            .text{
                z-index: 10;
                position: absolute;
                left: 10%;
                top:40%;
                width:80%;
                color:white;
                p:nth-child(1){
                    font-size: 50px;
                    font-weight: bold;
                    width:50%;
                    overflow: hidden;
                    height:70px;
                }
                p:nth-child(2){
                    font-size: 20px;
                    line-height: 35px;
                    width:35%;
                    margin-top: 30px;
                  font-family: 'light';
                    font-weight: lighter;
                }
                p:nth-child(3){
                    font-size: 12px;
                    color:rgba(255,255,255,.2);
                    width:30%;
                    margin-top: 30px;
                    line-height: 20px;
                    span{
                        margin-left: 5px;
                        letter-spacing: 0 !important;
                    }
                }
                span{
                    display: inline-block;
                    opacity: 0;
                    letter-spacing: 5px;
                    -webkit-transform: translate(100px, 0px);
                    -ms-transform: translate(100px, 0px);
                    transform: translate(100px, 0px);
                    -webkit-transition: 0.8s cubic-bezier(0.32, 0.6, 0.4, 1.21);
                    transition: 0.8s cubic-bezier(0.32, 0.6, 0.4, 1.21);
                }
                i{
                    font-size: 100px;
                    color:rgba(255,255,255,.2);
                }
            }
            .enp{
                p{
                    width:80% !important;}
            }
            .ne{
                position: absolute;
                right:0;
                top:50%;
                width:10%;
                text-transform: uppercase;
                color:white;
                display: flex;
                flex-direction: row;
                align-items: center;
                font-family: 'futu';
                span:nth-child(2){
                    display: inline-block;
                    height:1px;
                    background-color: rgba(255,255,255,.2);
                    width:80%;
                }
            }
            .scr{
                width:10%;
                position: absolute;
                left:45%;
                bottom:0;
                z-index: 1000;
                height:120px;
                text-align: center;
                text-transform: uppercase;
                display: flex;
                flex-direction: column;
                justify-content: center;
                span:nth-child(1){
                    color:white;
                    padding-bottom: 10px;
                    font-size: 12px;
                }
                span:nth-child(2){
                    width:1px;
                    height:100px;
                    background-color: rgba(255,255,255,.2);
                    position: relative;
                    margin-left: 50%;
                }
                span:nth-child(2)::before{
                    content:'';
                    display: none;
                    width:1px;
                    height:20px;
                    position: absolute;
                    top:30%;
                    left:0;
                    animation: runa 2s infinite ease;
                    background-color: white;
                }
                @keyframes runa {
                    from{
                        top:0;
                    }
                    to{
                        top:100%;
                    }
                }
            }
        }
        .swiper-slide-active{
            .text{
                span{
                    opacity: 1;
                    /* letter-spacing: 0; */
                    -webkit-transform: translate(0px, 0px);
                    -ms-transform: translate(0px, 0px);
                    transform: translate(0px, 0px);
                }
            }
        }
    }
    @media screen and (min-width:2500px){
  .swiper{
      .item{
          .text{
              p:nth-child(2){
                  width:60%;
              }
          }
      }
  }
    }
    @media screen and (max-width: 1440px){
        .swiper{
            .item{
                .text{
                    p:nth-child(1), p:nth-child(2){
                        width:100%;
                    }
                }
                .enp{
                    p{
                        width:auto !important;
                        height:auto !important;
                        line-height: 30px !important;
                    }
                    p:nth-child(1){
                        span{
                            line-height: 60px;
                        }
                    }
                }
            }
        }
    }
    @media screen and (max-width:1279px){
        .swiper{
            .item{
               .text{
                   top:30%;
                   width:90%;
                   left:5%;
                   p:nth-child(1){
                       font-size: 22px;
                       width:100%;
                       height:40px;
                   }
                   p:nth-child(2){
                       font-size: 14px;
                       width:90%;
                       margin-top: 10px;
                   }
                   p:nth-child(3){
                       width:90%;
                   }
               }
                .enp{
                    p{
                        width:auto !important;
                        height:auto !important;
                        line-height: 40px !important;
                    }
                }
                .ne{
                   display: none;
                }
            }
        }
    }
}
</style>
<style scoped>
    .banner .swiper-pagination {
        top: 55%;
        right:1.5%;
        width: 15%;
    }
    .banner .swiper-pagination>>>.swiper-pagination-bullet {
        position: relative;
        width: 60px;
        height:4px;
        border-radius: 20px;
        margin: 0 5px;
        background-color: transparent;
    }
    .banner .swiper-pagination>>>.swiper-pagination-bullet::before{
        position: absolute;
        left:0;
        top:0;
        width:8px;
        height:8px;
        border-radius: 50%;
        background-color: white;
        content:'';
        display: inline-block;
    }
    .banner .swiper-pagination>>>.swiper-pagination-bullet:focus{
        outline: none;
    }
    .banner .swiper-pagination>>>.swiper-pagination-bullet i{
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: 0;
        height:8px;
        border-radius: 20px;
        background-color: #fff;
    }
    @media screen and (max-width:1440px){
        .banner .swiper-pagination {
            width: 20%;
        }
    }
    @media screen and (max-width:450px){
        .banner .swiper-pagination{
            width:60%;
            top:65%;
        }
        .banner .swiper-pagination>>>.swiper-pagination-bullet{
            width:40px;
        }
    }
</style>